import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text as ChakraText,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { colors } from '../../../ui-kit'

interface DeletePathPolicyModalProps {
  isOpenDeletePathPolicy: boolean
  name: string
  onSubmit(): Promise<void>
  onCloseDeletePathPolicy(): void
}

export const DeletePathPolicyModal = ({
  isOpenDeletePathPolicy,
  name,
  onCloseDeletePathPolicy,
  onSubmit,
}: DeletePathPolicyModalProps): React.ReactElement => {
  const [isDeleteDisabled, setIsDeleteDisabled] = useState(false)
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={isOpenDeletePathPolicy}
      onClose={onCloseDeletePathPolicy}
      size="xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {t('delete_path_policy', 'Delete path policy')}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Trans t={t} i18nKey="delete_path_policy_modal_description">
            <ChakraText color={colors.appBattleshipGrey}>
              Path policy {{ name }} will be permanently deleted. This will
              remove the policy from every path that currently uses it. Click on
              submit to proceed with the operation.
            </ChakraText>
          </Trans>
        </ModalBody>
        <ModalFooter borderTop="1px solid #e7eaf0" style={{ gap: '1em' }}>
          <Button
            onClick={onCloseDeletePathPolicy}
            variant="outline"
            isDisabled={isDeleteDisabled}
          >
            {t('cancel', 'Cancel')}
          </Button>
          <Button
            type="submit"
            colorScheme="appRed"
            isDisabled={isDeleteDisabled}
            onClick={async () => {
              setIsDeleteDisabled(true)
              await onSubmit()
              setIsDeleteDisabled(false)
              onCloseDeletePathPolicy()
            }}
          >
            {t('submit', 'Submit')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
